import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';
import {IMantMermaAsigClient} from '../modelos/IMantMermaAsigClient.js';

@Injectable({
  providedIn: 'root'
})
export class PorcentajeMermaAsigClienteService {

  private diccionarioModulo: any;
  private url: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
  }

  obtener(): Observable<IMantMermaAsigClient[]> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.mantMermaAsigClient.obtenerTodo
    );
  }

  crear(request: IMantMermaAsigClient) {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.mantMermaAsigClient.crear,
      request
    );
  }

  actualizar(request: IMantMermaAsigClient): Observable<any> {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.mantMermaAsigClient.actualizar,
      request
    );
  }

}
